import React from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

export function CheckboxForm({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  withFeedbackLabel = true,
  label,
  customFeedbackLabel,
  onChange,
  type = "checkbox",
  labelPlacement = "end",
  ...props
}) {
  const { value = "" } = field;
  return (
    <>
      <div className="form-group d-flex">
        {/* <input type="checkbox" style={{ display: "none" }} /> */}
        <label className="switch switch-md switch-primary switch-single">
          <input
            type={type}
            className="m-1"
            {...field}
            {...props}
            checked={value}
          />
          <span />
          {label && <label className="ml-2 text-center">{label}</label>}
        </label>
        {withFeedbackLabel && touched[field.name] && (
          <FieldFeedbackLabel
            error={errors[field.name]}
            touched={touched[field.name]}
            label={label}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        )}
      </div>
    </>
  );
}
